import { Alert } from '@skupreme/shared/ui';
import { useLocation } from 'react-router';
import { useAuth } from '@contexts/auth';
import { supportsAccountLevel } from './pages';
import { useAccountView } from './useAccountView';
import { useDivisionLevelOffAccountPages } from './useDivisionLevelOffAccountPages';

/* EN-4396: the one copy of the notice. `division` is the division the page
   shows instead of all of them. */
const noticeText = (division: string) =>
  `All divisions isn't available on this page yet. You're seeing ${division} only. Pick a division in the sidebar to switch.`;

/**
 * At the account level, a page that cannot show every division yet says which
 * division it shows. Nothing otherwise, and nothing while the level is not
 * known to be account (useAccountView falls back to the division level).
 * Not dismissible: it states what the page is showing. Mounted app-wide, it
 * also holds such a page's order reads at the division level.
 */
export function AccountLevelNotice() {
  useDivisionLevelOffAccountPages();
  const { level } = useAccountView();
  const { pathname } = useLocation();
  const { currentOrgInfo } = useAuth();

  if (level !== 'account' || supportsAccountLevel(pathname)) return null;

  return (
    <div className="sk:px-5 sk:pt-[15px]">
      <Alert tone="info">
        {noticeText(currentOrgInfo?.company_name ?? 'one division')}
      </Alert>
    </div>
  );
}
